export const SPEED = 0.5;
export const WIDTH = 64;
export const HEIGHT = 64;
export const IS_PLAYING = true;